import type { ReactNode } from 'react'

interface PageHeroProps {
  eyebrow: string
  title: string
  intro: string
  children?: ReactNode
  compact?: boolean
}

export function PageHero({ eyebrow, title, intro, children, compact = false }: PageHeroProps) {
  return (
    <section className={`page-hero ${compact ? 'page-hero-compact' : ''}`}>
      <div className="container page-hero-inner">
        <span className="eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{intro}</p>
        {children && <div className="hero-actions">{children}</div>}
      </div>
    </section>
  )
}
